module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ck-6f73c68e1aca3060e929c43108bb8a3f.svg";